export default __webpack_public_path__ + "static/media/children_with_nurse_playroom.de345d36.png";